---
title: "Điều khoản và điều kiện"
path: "/vi/dieu-khoan-va-dieu-kien"
seoTitle: "Điều khoản và điều kiện | Dutch Passion Thailand"
seoDescription: "Tóm tắt điều khoản về đặt hàng, thanh toán, giao hàng và trả hàng khi mua hạt giống cần sa Dutch Passion tại Thái Lan. Vui lòng đọc trước khi đặt."
---

> **Bản tiếng Việt này là một bản tóm tắt và do máy dịch.** Chỉ
> [điều khoản và điều kiện bản tiếng Anh](/terms-and-conditions) mới có giá trị pháp lý. Nếu có
> khác biệt, bản tiếng Anh được ưu tiên. Trang này đang chờ người bản ngữ hiệu đính.

## Phạm vi áp dụng

Các điều khoản này áp dụng cho mọi đơn hàng đặt trên dutchpassion.co.th. Khi xác nhận đặt hàng,
bạn đồng ý với chúng.

## Đặt hàng và thanh toán

Giá hiển thị tính bằng baht Thái và đã bao gồm thuế. Bạn có thể chọn thanh toán khi nhận hàng,
thẻ tín dụng hoặc thẻ ghi nợ, PromptPay hoặc mobile banking. Thông tin thẻ được gửi thẳng tới
đơn vị thanh toán Omise và không đi qua trang web này.

## Giao hàng

Đơn đặt trước 15:00 ngày làm việc được gửi đi trong cùng ngày. Bao bì kín đáo: nhìn bên ngoài
không biết được bên trong là gì. Chúng tôi chỉ giao trong lãnh thổ Thái Lan: gửi bưu điện thường
có giá 100 baht cho toàn Thái Lan, kể cả Bangkok, và thường mất 1–3 ngày làm việc. Trong nội
thành Bangkok còn có tùy chọn giao trong ngày với giá 250 baht.

## Hủy đơn và trả hàng

Bạn có thể liên hệ với chúng tôi kèm mã đơn hàng để hủy hoặc sửa đơn, miễn là đơn chưa được gửi
đi. Hạt giống không được nhận lại, dù đã mở hay chưa, và đơn đã giao thì không hoàn tiền. Nếu
hàng bị lỗi hoặc không đúng với đơn, hãy liên hệ với chúng tôi.

## Luật áp dụng

Các điều khoản này chịu sự điều chỉnh của pháp luật Vương quốc Thái Lan. Nếu có thắc mắc, hãy gửi
email tới info@dutchpassion.co.th.
